<template>
    <div class="add-customer-dialog">
        <el-dialog :visible="visible" title="新增客户" destroy-on-close width="1230px" :close-on-click-modal='false'
            :close-on-press-escape='false' @close="handleClose">
            <div class="add-customer-form-box">
                <dc-form ref='dcForm' refName="customerForm" :row="addNewMainData" :config="FIELDS"
                    :col="3" @data-changed="handleFormDataChange"
                    labelWidth="120px" class="add-customer-form">
                    <template v-slot:form-append="{ form, itemSetting, rIndex }">
                        <el-form-item :label="itemSetting.label" :prop="itemSetting.prop"
                            :label-width="itemSetting.labelWidth">
                            <div class="custoomer-input" v-if="itemSetting.prop === 'customerBodyType'">
                                <lots-select
                                    @change="handleFormDataChange({ data: form[itemSetting.prop], form, itemSetting })"
                                    class=" customer-select" :optionsKey="itemSetting.optionsKey" :disabled="true"
                                    v-model="form[itemSetting.prop]"></lots-select>
                                <span class="form-item-text"
                                    v-if="showFieldStatus"
                                    @click="openCusomterGroupDialog">
                                    引用集团客户
                                </span>
                            </div>
                            <div class="custoomer-input"
                                v-else-if="itemSetting.prop === 'customerName' && showFieldStatus">
                                <inputComplete class="customer-select customer-dup" placeholder="请输入"
                                    :inputValue="form[itemSetting.prop]" :config="inputConfig"
                                    @handleIconClick="searchInputHandle" @clickItem="clickCompleteHandle"
                                    @inputHandle="inputHandle">
                                </inputComplete>
                                <!-- <el-input type="text" class="customer-select" v-model="form[itemSetting.prop]"
                                 @input="handleFormDataChange({ data: form[itemSetting.prop], form, itemSetting })" /> -->
                                <span class="form-item-text" @click="openDuplicateDialog">
                                    查重
                                </span>
                            </div>
                            <div class="custoomer-input" v-else-if="itemSetting.prop === 'societyCreditCode'">
                                <el-input type="text" class="customer-select" placeholder="请输入"
                                    v-model.trim="form[itemSetting.prop]" clearable :disabled="itemSetting.disabled"
                                    @input="data => inputChange(data, itemSetting.prop)" />
                                <span class="form-item-text" @click="openBusinessDialog">
                                    工商信息
                                </span>
                            </div>
                            <div class="customer-phone"
                                v-else-if="itemSetting.prop === 'customerName' && addNewMainData.customerBodyType === '0'">
                                <el-input type="text" placeholder="姓名" class="customer-other customer-other-name"
                                    v-model="form[itemSetting.prop]" clearable
                                    @input="data => inputChange(data, itemSetting.prop)" />
                                <!-- <inputComplete class="customer-other" placeholder="客户姓名"
                                    :inputValue="form[itemSetting.prop]" :config="inputConfig"
                                    @handleIconClick="searchInputHandle" @clickItem="clickCompleteHandle"
                                    @inputHandle="inputHandle">
                                </inputComplete> -->
                                <span class="form-other-text" @click="openBusinessDialog">
                                    -
                                </span>
                                <el-input type="text" placeholder="手机号" class="customer-other phone-customer"
                                    v-model.trim="addNewMainData.telPhone" clearable
                                    @change="data => inputChange(data, 'telPhone')" />
                                <span class="form-item-text" @click="openDuplicateDialog">
                                    查重
                                </span>
                            </div>

                        </el-form-item>
                    </template>
                </dc-form>
            </div>

            <span slot="footer">
                <el-button type="primary" size="mini" :loading="nextVerifyLoading" @click="nextCheck">下一步</el-button>
                <el-button type="primary" size="mini" :loading="privilegeLoading" v-has="authorityCode.privilege"
                    @click="privilegeCheck">特权新增</el-button>
            </span>
        </el-dialog>

        <!-- 引用集团客户 -->
        <advance-dialog ref="advanceDialog" @confirm="detailSearchSure"></advance-dialog>
        <!-- 工商信息 -->
        <business-dialog ref="businessDialog" @confirm="detailSearchSure"></business-dialog>
        <!-- 查重 -->
        <customer-duplicate-dialog ref="duplicateDialog" @confirm="detailSearchSure"></customer-duplicate-dialog>
    </div>
</template>

<script>
import { ref, reactive, computed } from '@vue/composition-api';
// import lotsPagination from '@/components/lots/lotsPagination/Index';
import { tableConfig, customerGroupConfig, inputConfig } from './config.js';
import { getCustomerAddVerify, customerPrivilegeVerify, getRiskInfoWithTyc, getCustomerRiskLevel } from '@/modules/mdm/api/customer/customerManage.js';
import { Message } from 'element-ui';
import dcForm from '@/modules/mdm/components/form/Index.vue';
import inputComplete from '@/modules/mdm/components/inputComplete/Index.vue';
import LotsSelect from '@/components/lots/lotsSelect/Index';
import advanceDialog from '@/components/lots/otpAdvanceDialog';
import customerDuplicateDialog from '../customerDuplicateDialog/Index.vue';
import businessDialog from '../businessDialog/Index.vue';
import { phoneReg } from '@/modules/mdm/utils/regList.js';
import store from '@/store';
import _ from 'lodash';
import btnAuthority from '@/modules/mdm/btnAuthority.js';
// import tableMutiAdvance from '@/modules/mdm/views/contractModules/components/tableMutiAdvance/Index.vue';
export default {
    components: { dcForm, LotsSelect, advanceDialog, customerDuplicateDialog, businessDialog, inputComplete },
    props: {

    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const config = reactive(tableConfig);
        const emit = setupContext.emit;

        const _addNewMainData = {
            customerBodyType: '',
            customerName: '',
            isImpExpCustomer: '',
            customerChannel: '' // 内外部业务：0 内部 1 外部
        };
        const authorityCode = reactive(btnAuthority.customerManage);
        const addNewMainData = ref(_.cloneDeep(_addNewMainData));
        const showFieldStatus = computed(() => {
            const { customerBodyType } = addNewMainData.value;
            return ['1', '2'].includes(customerBodyType);
        });
        const FIELDS = computed(() => {
            const { customerBodyType, customerChannel } = addNewMainData.value;
            config.fields.forEach(item => {
                if (['societyCreditCode', 'ebcuLegalEntity', 'ebcuOrgBarcode', 'placeholder'].includes(item.prop)) {
                    item.visible = customerBodyType === '1';
                }
                if (['idNumber'].includes(item.prop)) {
                    item.visible = customerBodyType === '0';
                }
                if (['societyCreditCode'].includes(item.prop)) {
                    item.disabled = customerChannel === '1';
                }
                if (['isImpExpCustomer'].includes(item.prop)) {
                    item.disabled = ['0', '2'].includes(customerBodyType);
                }
                if (['ebcuBusinessNo'].includes(item.prop)) {
                    item.label = customerBodyType === '2' ? '注册号' : '营业执照号';
                    item.visible = ['1', '2'].includes(customerBodyType);
                }
                if (['sinosureCode', 'ebcuNameEn'].includes(item.prop)) {
                    item.visible = customerBodyType === '2';
                }
            });
            return config.fields;
        });

        // eslint-disable-next-line complexity
        const handleFormDataChange = ({ data, form, itemSetting }) => {
            if (itemSetting.prop === 'customerChannel') {
                if (addNewMainData.value.customerBodyType === '1' && addNewMainData.value.customerChannel === '1' && data !== '1') {
                    // addNewMainData.value = _.cloneDeep(_addNewMainData);
                    addNewMainData.value = Object.assign(_.cloneDeep(_addNewMainData), showParams.value, formatInitData(data));
                    setupContext.root.$nextTick(() => {
                        setupContext.refs.dcForm.$refs.customerForm.clearValidate();
                    });
                    return;
                    // setupContext.refs.upholdHealder.updataInitData(addNewMainData.value);
                }
            } else if (itemSetting.prop === 'ebcuNameEn') {
                form['ebcuNameEn'] = form['ebcuNameEn'].trim();
            }
            addNewMainData.value = Object.assign(addNewMainData.value, form);
        };

        const visible = ref(false);
        const showParams = ref({});
        const show = (val) => {
            visible.value = true;
            showParams.value = val;
            initDialog(val);
        };
        const initDialog = (val) => {
            addNewMainData.value = Object.assign({}, _addNewMainData, val);
            setupContext.root.$nextTick(() => {
                setupContext.refs.dcForm.$refs.customerForm.clearValidate();
            });
        };
        const handleClose = () => {
            visible.value = false;
        };
        const detailSearchSure = (data) => {
            // 将返回数据添加到map里，用于高级搜索清空时，顺带清空其他关联属性
            addNewMainData.value = Object.assign(addNewMainData.value, data);
        };
        const openCusomterGroupDialog = () => {
            setupContext.refs.advanceDialog.show(true, customerGroupConfig);
        };
        const openDuplicateDialog = () => {
            // switch (addNewMainData.value.customerBodyType) {
            if (addNewMainData.value.customerBodyType === '0') {
                if (addNewMainData.value.customerName && addNewMainData.value.telPhone) {
                    setupContext.refs.duplicateDialog.show(`${addNewMainData.value.customerName}-${addNewMainData.value.telPhone}`);
                    return;
                }
                return Message.warning('请填写客户名称以及手机号');
            } else {
                if (addNewMainData.value.customerName) {
                    setupContext.refs.duplicateDialog.show(`${addNewMainData.value.customerName}`);
                    return;
                }
                return Message.warning('请填写客户名称');
            }
        };
        const openBusinessDialog = () => {
            if (addNewMainData.value.societyCreditCode && addNewMainData.value.customerName) {
                setupContext.refs.businessDialog.show({ societyCreditCode: addNewMainData.value.societyCreditCode, customerName: addNewMainData.value.customerName });
                return;
            }
            return Message.warning('请填写客户名称和社会信用代码');
        };
        const clickCompleteHandle = (data) => {
            if (showFieldStatus.value) {
                addNewMainData.value = {
                    ...addNewMainData.value,
                    ...data
                };
            }
        };
        const inputChange = (data, prop) => {
            addNewMainData.value[prop] = data;
        };
        // 通过弹框信息自动带入的字段： 法人代表、营业执照、组织机构代码、身份证号、集团客户编码；

        // 通过接口信息自动带入的字段：风险等级、企业性质、经营状态、注册金额、国家、省份、城市、地址；

        // 字段默认值： 、国家=中国、客户状态=新建、客户审批状态=未审批；
        const initFormData = {
            isVirtualCustomer: 'N', // 虚拟客户-否
            ebcuEbplCountryCode: 'CN', // 需产品待定默认值是什么
            customerStatus: '0', // 客户状态-新增
            approvalStatus: '0', // 审批状态-未审批
            sysSource: 'LCRM'
        };

        const getInitInsertData = (data) => {
            const params = {
                ...initFormData
            };
            if (data.customerBodyType === '2') {
                params.isImpExpCustomer = addNewMainData.value.isImpExpCustomer;
                params.ebcuEbplCountryCode = '';
                params.ebcuTaxpayersType = '2';
            }
            const initCustomerData = {
                ebcuTaxpayers: data.customerName,
                customerOwnerCode: store.getters.user.userCode,
                customerOwnerName: store.getters.user.userName,
                isCertification: '1',
                teamType: null
            };
            if (data.customerChannel === '2') {
                params.ebcuBuCode = '10'; // 内外渠=外部时带出安得智联
                initCustomerData.isRelatedTransaction = '0'; // 内外渠=外部时带出否 是否关联交易 是否POS机收款 所属事业部
                initCustomerData.receiveByPos = '0';
            }
            if (data.customerChannel === '1') { // 1:内容
                params.isGroupCustomer = '0'; // 内外渠为纯外部或美的渠道时带出外部，内外渠为内部时带出内部(外部:1;内部:0)
            } else {
                params.isGroupCustomer = '1';
            }
            // 弹框对应带入客户控制类型为0非法人时，默认私营企业
            if (data.customerBodyType === '0') {
                initCustomerData.ebcuPlatformNature = '10';
            }
            if (addNewMainData.value.customerBodyType === '0') {
                // 非法人时换字段
                initCustomerData.personalName = data.customerName;
                initCustomerData.telPhone = addNewMainData.value.telPhone;
                initCustomerData.customerName = data.customerName + '-' + addNewMainData.value.telPhone;
                delete params.customerName;
            }
            Object.assign(params, initCustomerData);
            return params;
        };
        const getInsertData = (isPrivilege = false) => {
            const params = {
                societyCreditCode: addNewMainData.value.societyCreditCode,
                customerName: addNewMainData.value.customerName
            };
            // 特权新增时, 无社会信用代码不请求
            if (!params.societyCreditCode && isPrivilege) {
                return { code: 0, data: {} };
            }
            return getRiskInfoWithTyc(params);
        };
        const getRiskLevelData = (isPrivilege) => {
            if (addNewMainData.value.customerBodyType !== '1') {
                return { code: 0, data: {} };
            }
            if (!addNewMainData.value.societyCreditCode) {
                return { code: 0, data: {} };
            }
            // 特权新增时, 无社信号不请求
            if (!addNewMainData.societyCreditCode && isPrivilege) {
                return { code: 0, data: {} };
            }
            const params = {
                customerName: addNewMainData.value.customerName,
                societyCreditCode: addNewMainData.value.societyCreditCode
            };
            return getCustomerRiskLevel(params);
        };
        const getParams = (data) => {
            const params = _.pick(data, [
                'societyCreditCode', // 社会信用代码
                'ebcuBusinessNo', // 营业执照号/注册号
                'ebcuOrgBarcode', // 组织机构代码
                'ebcuLegalEntity', // 法人代表
                'ebcuTaxRegistNo', // 纳税号
                'sinosureCode', // 中信保编码
                'idNumber', // 身份证
                'ebcuTaxpayers', // 纳税登记人
                'ebcuTaxpayersType', // 纳税人类型
                'ebcuPlatformNature', // 企业性质
                'ebcuRegisteredCapital', // 注册金额
                'businessScope', // 经营范围
                'ebcuEbplCountryCode', // 国家
                'ebcuEbplProvinceCode', // 省
                'ebcuEbplCityCode', // 市
                'ebcuDistricts', // 区
                'ebcuTowns', // 乡镇/街道
                'ebcuAddress', // 地址
                'ebcuRegistrationDate', // 成立日期
                'regStatus', // 经营状态
                'tycIndustry', // 天眼参考行业
                'staffNumRange', // 人员规模
                'socialStaffNum', // 参保人数
                'actualCapital', // 实收注册资本
                'isMicroEnt', // 实收注册资本
                'isCertification', // 智汇签验真
                'customerShortName', // 客户简称
                'ebcuNameEn' // 英文名称
            ]);
            if (params.ebcuEbplCountryCode) {
                params.ebcuEbplCountryCode = 'CN';
            }
            // 设置默认值
            const newParams = {
                ...params,
                ebcuBusinessNo: params.ebcuBusinessNo || '-', // 营业执照号/注册号
                ebcuOrgBarcode: params.ebcuOrgBarcode || '-', // 组织机构代码
                ebcuLegalEntity: params.ebcuLegalEntity || '-', // 法人代表
                ebcuTaxpayers: params.ebcuTaxpayers || '-', // 纳税登记人
                ebcuAddress: params.ebcuAddress || '-', // 地址
                tycAddress: params.ebcuAddress // 注册地址
            };
            return newParams;
        };

        const nextVerifyLoading = ref(false);
        const nextCheck = async () => {
            if (addNewMainData.value.customerBodyType === '0' && addNewMainData.value.customerChannel === '1') {
                return Message.warning('当客户控制类型为非法人时,不可以选择内部渠道,请重新选择');
            }
            if (!RegExp(phoneReg).test(addNewMainData.value.telPhone) && addNewMainData.value.customerBodyType === '0') {
                return Message.warning('手机号码格式不对');
            }
            // eslint-disable-next-line complexity
            setupContext.refs.dcForm.validateForm().then(async () => {
                const params = {
                    ...addNewMainData.value,
                    ...getInitInsertData(addNewMainData.value)
                };
                // customerChannel: 1 内部
                if (params.customerChannel === '1' && !params.originalGroupCode) {
                    return Message.warning('当内外渠=内部时，显示“引用集团客户”字段（必填）');
                }
                nextVerifyLoading.value = true;
                try {
                    const verifyParams = {
                        ..._.cloneDeep(addNewMainData.value)
                    };
                    if (verifyParams.customerBodyType === '0') {
                        // 非法人时换字段
                        verifyParams.personalName = verifyParams.customerName;
                        delete verifyParams.customerName;
                    }
                    const verifyRes = await getCustomerAddVerify(verifyParams);
                    if (verifyRes && +verifyRes.code === 0 && verifyParams.customerBodyType === '1') {
                        // const dataRes = await getInsertData();
                        Promise.all([getInsertData(), getRiskLevelData()]).then(resArr => {
                            if ((resArr[0] && +resArr[0].code === 0) && (resArr[1] && +resArr[1].code === 0)) {
                                emit('addNewConfirm', {
                                    ...getParams(resArr[0].data),
                                    ...params,
                                    ...initFormData,
                                    ..._.pick(resArr[1].data, [
                                        'riskLevel'
                                    ])
                                }, 'new', '新增客户');
                                handleClose();
                            }
                        });
                        nextVerifyLoading.value = false;
                    } else if (verifyRes && +verifyRes.code === 0 && verifyParams.customerBodyType === '0') {
                        emit('addNewConfirm', {
                            ...params,
                            ...initFormData
                        }, 'new', '新增客户');
                        handleClose();
                    } else if (verifyRes && +verifyRes.code === 0 && verifyParams.customerBodyType === '2') {
                        emit('addNewConfirm', {
                            ...params
                        }, 'new', '新增客户');
                        handleClose();
                    }
                    nextVerifyLoading.value = false;
                } catch {
                    nextVerifyLoading.value = false;
                }
            });
        };
        const getPrivilegeInsertData = (data) => {
            const params = {
                ...initFormData
            };
            const initCustomerData = {
                ebcuTaxpayers: data.customerName,
                customerOwnerCode: store.getters.user.userCode,
                customerOwnerName: store.getters.user.userName,
                isCertification: '1'
            };
            if (data.customerBodyType === '2') {
                params.isImpExpCustomer = addNewMainData.value.isImpExpCustomer;
                params.ebcuEbplCountryCode = '';
                params.ebcuTaxpayersType = '2';
            }
            if (data.customerChannel === '2') {
                params.ebcuBuCode = '10'; // 内外渠=外部时带出安得智联
                initCustomerData.isRelatedTransaction = '0'; // 内外渠=外部时带出否 是否关联交易 是否POS机收款 所属事业部
                initCustomerData.receiveByPos = '0';
            }
            if (data.customerChannel === '1') { // 1:内容
                params.isGroupCustomer = '0'; // 内外渠为纯外部或美的渠道时带出外部，内外渠为内部时带出内部(外部:1;内部:0)
            } else {
                params.isGroupCustomer = '1';
            }
            // 弹框对应带入客户控制类型为0非法人时，默认私营企业
            if (params.customerBodyType === '0') {
                initCustomerData.ebcuPlatformNature = '10';
            }
            if (addNewMainData.value.customerBodyType === '0') {
                // 非法人时换字段
                initCustomerData.personalName = data.customerName;
                initCustomerData.telPhone = addNewMainData.value.telPhone;
                initCustomerData.customerName = data.customerName + '-' + addNewMainData.value.telPhone;
                delete params.customerName;
            }
            Object.assign(params, initCustomerData);
            return params;
        };
        const privilegeLoading = ref(false);
        // eslint-disable-next-line complexity
        const privilegeCheck = async () => {
            if (addNewMainData.value.customerBodyType === '0' && addNewMainData.value.customerChannel === '1') {
                return Message.warning('当客户控制类型为非法人时,不可以选择内部渠道,请重新选择');
            }
            if (!RegExp(phoneReg).test(addNewMainData.value.telPhone) && addNewMainData.value.customerBodyType === '0') {
                return Message.warning('手机号码格式不对');
            }
            const params = {
                ...addNewMainData.value,
                ...getPrivilegeInsertData(addNewMainData.value)
            };
            // customerChannel: 1 内部
            if (params.customerChannel === '1' && !params.originalGroupCode) {
                return Message.warning('当内外渠=内部时，请引用集团客户进行操作!');
            }
            privilegeLoading.value = true;
            try {
                const privilegeVerifyParams = {
                    ..._.cloneDeep(addNewMainData.value)
                };
                if (privilegeVerifyParams.customerBodyType === '0') {
                    // 非法人时换字段
                    privilegeVerifyParams.personalName = privilegeVerifyParams.customerName;
                    delete privilegeVerifyParams.customerName;
                }
                const verifyRes = await customerPrivilegeVerify(privilegeVerifyParams);
                if (verifyRes && +verifyRes.code === 0 && privilegeVerifyParams.customerBodyType === '1') {
                    // const dataRes = await getInsertData();
                    Promise.all([getInsertData(true), getRiskLevelData(true)]).then(resArr => {
                        if ((resArr[0] && +resArr[0].code === 0) && (resArr[1] && +resArr[1].code === 0)) {
                            emit('addNewConfirm', {
                                ...getParams(resArr[0].data),
                                ...params,
                                ...initFormData,
                                isPrivilege: 1,
                                ..._.pick(resArr[1].data, [
                                    'riskLevel'
                                ])
                            }, 'new', '新增客户');
                            handleClose();
                        }
                    });
                    privilegeLoading.value = false;
                } else if (verifyRes && +verifyRes.code === 0 && privilegeVerifyParams.customerBodyType === '0') {
                    emit('addNewConfirm', {
                        ...params,
                        ...initFormData,
                        isPrivilege: 1
                    }, 'new', '新增客户');
                    handleClose();
                } else if (verifyRes && +verifyRes.code === 0 && privilegeVerifyParams.customerBodyType === '2') {
                    emit('addNewConfirm', {
                        ...params,
                        isPrivilege: 1
                    }, 'new', '新增客户');
                    handleClose();
                }
                privilegeLoading.value = false;
            } catch {
                privilegeLoading.value = false;
            }
        };
        const searchInputHandle = () => {

        };
        const formatInitData = (val) => {
            const initData = {
                customerChannel: val,
                isImpExpCustomer: addNewMainData.value.isImpExpCustomer
            };
            return Object.assign(_.cloneDeep(_addNewMainData), showParams.value, initData);
        };
        const inputHandle = (data) => {
            addNewMainData.value = Object.assign(_.cloneDeep(_addNewMainData), showParams.value, formatInitData(addNewMainData.value.customerChannel));
            setupContext.root.$nextTick(() => {
                setupContext.refs.dcForm.$refs.customerForm.clearValidate();
            });
            addNewMainData.value.customerName = data;
        };
        return {
            emit,
            config,
            addNewMainData,
            FIELDS,
            visible,
            inputConfig,
            nextVerifyLoading,
            privilegeLoading,
            authorityCode,
            showFieldStatus,
            handleFormDataChange,
            show,
            handleClose,
            detailSearchSure,
            openCusomterGroupDialog,
            openDuplicateDialog,
            openBusinessDialog,
            nextCheck,
            privilegeCheck,
            searchInputHandle,
            inputHandle,
            clickCompleteHandle,
            inputChange
        };
    }
};
</script>
<style lang="less" scoped>
.customer-select {
    width: 65% !important;
}

.custoomer-input {
    display: flex;
}

.form-item-text {
    color: #409EFF;
    cursor: pointer;
    margin-left: 10px;
    width: 85px;
}

.customer-phone {
    display: flex;
}

.customer-other {
    width: calc(50% - 40px);
}

.phone-customer {
    margin-left: 8px;
}

.form-other-text {
    margin-left: 8px;
}
</style>
<style lang="less">
.add-customer-dialog {
    .add-customer-form-box {
        width: 100%;
        padding: 0 40px 0 0;
        box-sizing: border-box;
        height: 150px;

        .el-select {
            width: 100%;
        }
    }

    .add-customer-dialog-table {
        margin: 10px 0 5px 0;
    }
}

.add-customer-form-box .add-customer-form input {
    width: 175px;
}

.add-customer-dialog .add-customer-form-box .el-select,
.add-customer-dialog .add-customer-form-box .el-input {
    width: auto !important;
}
.add-customer-form-box .add-customer-form .customer-other input {
    width: 120px;
}
.add-customer-form-box .add-customer-form .customer-other-name input {
    width: 80px;
}
</style>
